<div class="bg-white m-2 p-2 border-round-lg">
  <p-stepper
    [activeStep]="config?.activeStep"
    [linear]="config?.linear ?? false"
    [orientation]="config?.orientation ?? 'horizontal'"
   
    [transitionOptions]="config?.transitionOptions ?? ''"
    (activeStepChange)="onActiveStepChange($event)"
  >
  <!-- [pStyleClass]="config?.styleClass ?? 'stepper'"-->
    <p-stepperPanel
      *ngFor="let panel of config?.panels"
      [header]="panel.header"
    >
      <ng-container *ngIf="config?.separator === false">
        <ng-template pTemplate="separator" />
      </ng-container>

      <ng-template
        pTemplate="content"
        let-nextCallback="nextCallback"
        let-prevCallback="prevCallback"
        let-index="index"
      >
        <div class="flex flex-column gap-2">
          <ng-container *ngIf="config?.activeStep === panel.index">
            <ng-container *ngTemplateOutlet="getStepContent(panel.index)" />
          </ng-container>

          <div *ngIf="config?.stepperButtonsVisible" class="flex gap-2">
            <ng-container *ngIf="config!.activeStep! > 0">
              <p-button
                size="small"
                [label]="config?.previousButtonLabel ?? ''"
                [icon]="config?.previousButtonIcon"
                [iconPos]="config?.previousButtonIconPosition ?? 'left'"
                [styleClass]="config?.previousButtonStyleClass"
                [disabled]="isPreviousButtonDisabled(panel)"
                [loading]="isPreviousButtonLoading(panel)"
                (onClick)="onPreviousClick(prevCallback, panel)"
              />
            </ng-container>
            <ng-container
              *ngIf="config!.activeStep! < config!.panels!.length - 1"
            >
              <p-button
                size="small"
                [label]="config?.nextButtonLabel ?? ''"
                [icon]="config?.nextButtonIcon"
                [iconPos]="config?.nextButtonIconPosition ?? 'left'"
                [styleClass]="config?.nextButtonStyleClass"
                [disabled]="isNextButtonDisabled(panel)"
                [loading]="isNextButtonLoading(panel)"
                (onClick)="onNextClick(nextCallback, panel)"
              />
            </ng-container>
            <ng-container
              *ngIf="config!.activeStep! === config!.panels!.length - 1"
            >
              <p-button
                size="small"
                [label]="config?.submitButtonLabel ?? ''"
                [icon]="config?.submitButtonIcon"
                [iconPos]="config?.submitButtonIconPosition ?? 'left'"
                [styleClass]="config?.submitButtonStyleClass"
                [disabled]="isSubmitButtonDisabled()"
                [loading]="isSubmitButtonLoading()"
                (onClick)="onSubmitClick()"
              />
            </ng-container>
          </div>
        </div>
      </ng-template>
    </p-stepperPanel>
  </p-stepper>
</div>
